<template>
        <div class="block" >
          <div style="padding: 10px ;text-align: left" v-if="options != null">
          <span class="demonstration">游戏:</span>
            <el-cascader
            v-model="svalue"
            :options="options"
            :placeholder="avalue"
            :props="{ expandTrigger: 'hover' }"
            @change="handleChange"
            >
            </el-cascader>
          </div>
                  <el-tabs type="border-card" v-if="gameId == 2">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.lsj">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                :data="list.lsj"
                                border
                                style="width: 100% height:100%" v-loading="loading" element-loading-text="加载中">
                                <el-table-column
                                    fixed
                                    prop="countDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="addRegNum"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <!--el-table-column
                                    prop="activeNum"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column-->
                                <el-table-column
                                    prop="payNum"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="payAmountTotal"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayNum"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayAmountTotal"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i>LTV</span>
                             <!--表格start-->
                                <el-form  :inline="true" :model="formInline" class="demo-form-inline">
                                    <el-form-item size="mini" label="开始时间:" :label-position="left">
                                        <el-date-picker
                                            v-model="startDate"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item size="mini" label="结束时间:" :label-position="left">
                                        <el-date-picker
                                            v-model="endDate"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button size="mini" icon="el-icon-search" round @click="handleClick">搜索</el-button>
                                    </el-form-item>
                                </el-form>
                                <el-table
                                :data="list.ltv"
                                border
                                style="width: 100% height:100%"
                                height="600" v-loading="loading" element-loading-text="加载中">
                                <el-table-column
                                    fixed
                                    prop="reDate"
                                    label="日期"
                                    width="95"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    fixed
                                    prop="register"
                                    label="新增"
                                    width="60"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_1"
                                    label="1日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_2"
                                    label="2日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_3"
                                    label="3日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_4"
                                    label="4日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_5"
                                    label="5日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_6"
                                    label="6日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_7"
                                    label="7日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_8"
                                    label="8日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_9"
                                    label="9日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_10"
                                    label="10日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_11"
                                    label="11日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_12"
                                    label="12日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_13"
                                    label="13日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_14"
                                    label="14日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_15"
                                    label="15日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_16"
                                    label="16日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_17"
                                    label="17日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_18"
                                    label="18日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_19"
                                    label="19日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_20"
                                    label="20日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_21"
                                    label="21日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_22"
                                    label="22日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_23"
                                    label="23日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_24"
                                    label="24日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_25"
                                    label="25日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_26"
                                    label="26日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_27"
                                    label="27日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_28"
                                    label="28日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_29"
                                    label="29日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_30"
                                    label="30日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_31"
                                    label="31日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_32"
                                    label="32日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_33"
                                    label="33日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_34"
                                    label="34日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_35"
                                    label="35日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_36"
                                    label="36日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_37"
                                    label="37日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_38"
                                    label="38日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_39"
                                    label="39日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_40"
                                    label="40日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_41"
                                    label="41日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_42"
                                    label="42日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_43"
                                    label="43日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_44"
                                    label="44日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_45"
                                    label="45日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_46"
                                    label="46日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_47"
                                    label="47日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_48"
                                    label="48日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_49"
                                    label="49日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_50"
                                    label="50日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>


                                 <el-table-column
                                    prop="ltv_51"
                                    label="51日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_52"
                                    label="52日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_53"
                                    label="53日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_54"
                                    label="54日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_55"
                                    label="55日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_56"
                                    label="56日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_57"
                                    label="57日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_58"
                                    label="58日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_59"
                                    label="59日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_60"
                                    label="60日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>

                            </el-table>
                            <!--表格end-->
                        </el-tab-pane >
                    </el-tabs>
                  <el-tabs type="border-card" v-if="gameId == 14 || gameId == 16 || gameId == 28 || gameId == 11 || gameId == 17 || gameId == 33 || gameId == 35">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.jszq">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                :data="list.jszq"
                                border
                                style="width: 100% height:100%"
                                height="600" v-loading="loading" element-loading-text="加载中">
                                <el-table-column
                                    fixed
                                    prop="createDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                    
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="disNewUsers"
                                    label="去重新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="newUsers"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeUsers"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="rechargeUsers"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="rechargePrice"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="newRechargeUsers"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="newRechargePrice"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payRate"
                                    label="活跃付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="arpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="arppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i>LTV</span>
                             <!--表格start-->
                                <el-form  :inline="true" :model="formInline" class="demo-form-inline">
                                    <el-form-item size="mini" label="开始时间:" :label-position="left">
                                        <el-date-picker
                                            v-model="startDate"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item size="mini" label="结束时间:" :label-position="left">
                                        <el-date-picker
                                            v-model="endDate"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button size="mini" icon="el-icon-search" round @click="handleClick">搜索</el-button>
                                    </el-form-item>
                                </el-form>
                                <el-table
                                :data="list.ltv"
                                border
                                style="width: 100% height:100%"
                                height="600" v-loading="loading" element-loading-text="加载中">
                                <el-table-column
                                    fixed
                                    prop="regDate"
                                    label="日期"
                                    width="95"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    fixed
                                    prop="regUsers"
                                    label="新增"
                                    width="60"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="yi"
                                    label="1日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="er"
                                    label="2日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="san"
                                    label="3日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="si"
                                    label="4日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="wu"
                                    label="5日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="liu"
                                    label="6日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="qi"
                                    label="7日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ba"
                                    label="8日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="jiu"
                                    label="9日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="shi"
                                    label="10日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="shiyi"
                                    label="11日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="shier"
                                    label="12日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="shisan"
                                    label="13日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="shisi"
                                    label="14日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="shiwu"
                                    label="15日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="shiliu"
                                    label="16日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="shiqi"
                                    label="17日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="shiba"
                                    label="18日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="shijiu"
                                    label="19日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ershi"
                                    label="20日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="eryi"
                                    label="21日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="erer"
                                    label="22日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ersan"
                                    label="23日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ersi"
                                    label="24日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="erwu"
                                    label="25日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="erliu"
                                    label="26日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="erqi"
                                    label="27日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="erba"
                                    label="28日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="erjiu"
                                    label="29日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sanshi"
                                    label="30日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sanyi"
                                    label="31日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="saner"
                                    label="32日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sansan"
                                    label="33日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sansi"
                                    label="34日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sanwu"
                                    label="35日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sanliu"
                                    label="36日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sanqi"
                                    label="37日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sanba"
                                    label="38日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sanjiu"
                                    label="39日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sishi"
                                    label="40日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="siyi"
                                    label="41日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sier"
                                    label="42日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sisan"
                                    label="43日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sisi"
                                    label="44日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="siwu"
                                    label="45日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="siliu"
                                    label="46日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="siqi"
                                    label="47日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="siba"
                                    label="48日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="sijiu"
                                    label="49日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="wushi"
                                    label="50日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>


                                 <el-table-column
                                    prop="wuyi"
                                    label="51日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="wuer"
                                    label="52日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="wusan"
                                    label="53日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="wusi"
                                    label="54日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="wuwu"
                                    label="55日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="wuliu"
                                    label="56日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="wuqi"
                                    label="57日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="wuba"
                                    label="58日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="wujiu"
                                    label="59日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="liushi"
                                    label="60日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>

                            </el-table>
                            <!--表格end-->
                        </el-tab-pane >
                    </el-tabs>
                  <el-tabs type="border-card" v-if="gameId == 333">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.zjfhand">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                :data="list.zjfhand"
                                border
                                v-loading="loading" element-loading-text="加载中"
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="countDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="addRegNum"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeNum"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payNum"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="payAmountTotal"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayNum"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayAmountTotal"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                    </el-tabs>
                  <el-tabs type="border-card" v-if="gameId == 3">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.zjfhios">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                v-loading="loading" element-loading-text="加载中"
                                :data="list.zjfhios"
                                border
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="countDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="addRegNum"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeNum"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payNum"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="payAmountTotal"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayNum"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayAmountTotal"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                    </el-tabs>
                  <el-tabs type="border-card" v-if="gameId == 44">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.srzgand">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                v-loading="loading" element-loading-text="加载中"
                                :data="list.srzgand"
                                border
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="countDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="addRegNum"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeNum"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payNum"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="payAmountTotal"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayNum"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayAmountTotal"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i>LTV</span>
                             <!--表格start-->
                                <el-form  :inline="true" :model="formInline" class="demo-form-inline">
                                    <el-form-item size="mini" label="开始时间:" :label-position="left">
                                        <el-date-picker
                                            v-model="startDate"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item size="mini" label="结束时间:" :label-position="left">
                                        <el-date-picker
                                            v-model="endDate"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button size="mini" icon="el-icon-search" round @click="handleClick">搜索</el-button>
                                    </el-form-item>
                                </el-form>
                                <el-table
                                :data="list.ltv"
                                border
                                style="width: 100% height:100%"
                                height="600" v-loading="loading" element-loading-text="加载中">
                                <el-table-column
                                    fixed
                                    prop="reDate"
                                    label="日期"
                                    width="95"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    fixed
                                    prop="register"
                                    label="新增"
                                    width="60"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_1"
                                    label="1日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_2"
                                    label="2日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_3"
                                    label="3日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_4"
                                    label="4日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_5"
                                    label="5日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_6"
                                    label="6日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_7"
                                    label="7日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_8"
                                    label="8日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_9"
                                    label="9日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_10"
                                    label="10日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_11"
                                    label="11日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_12"
                                    label="12日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_13"
                                    label="13日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_14"
                                    label="14日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_15"
                                    label="15日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_16"
                                    label="16日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_17"
                                    label="17日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_18"
                                    label="18日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_19"
                                    label="19日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_20"
                                    label="20日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_21"
                                    label="21日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_22"
                                    label="22日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_23"
                                    label="23日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_24"
                                    label="24日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_25"
                                    label="25日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_26"
                                    label="26日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_27"
                                    label="27日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_28"
                                    label="28日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_29"
                                    label="29日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_30"
                                    label="30日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_31"
                                    label="31日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_32"
                                    label="32日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_33"
                                    label="33日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_34"
                                    label="34日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_35"
                                    label="35日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_36"
                                    label="36日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_37"
                                    label="37日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_38"
                                    label="38日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_39"
                                    label="39日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_40"
                                    label="40日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_41"
                                    label="41日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_42"
                                    label="42日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_43"
                                    label="43日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_44"
                                    label="44日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_45"
                                    label="45日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_46"
                                    label="46日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_47"
                                    label="47日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_48"
                                    label="48日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_49"
                                    label="49日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_50"
                                    label="50日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>


                                 <el-table-column
                                    prop="ltv_51"
                                    label="51日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_52"
                                    label="52日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_53"
                                    label="53日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_54"
                                    label="54日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_55"
                                    label="55日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_56"
                                    label="56日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_57"
                                    label="57日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_58"
                                    label="58日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_59"
                                    label="59日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_60"
                                    label="60日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>

                            </el-table>
                            <!--表格end-->
                        </el-tab-pane >

                    </el-tabs>
                  
                  
                  
                  
                  
                  
                  
                  <el-tabs type="border-card" v-if="gameId == 4">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.srzgios">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                v-loading="loading" element-loading-text="加载中"
                                :data="list.srzgios"
                                border
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="countDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="addRegNum"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeNum"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payNum"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="payAmountTotal"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayNum"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayAmountTotal"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i>LTV</span>
                             <!--表格start-->
                                <el-form  :inline="true" :model="formInline" class="demo-form-inline">
                                    <el-form-item size="mini" label="开始时间:" :label-position="left">
                                        <el-date-picker
                                            v-model="startDate"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item size="mini" label="结束时间:" :label-position="left">
                                        <el-date-picker
                                            v-model="endDate"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button size="mini" icon="el-icon-search" round @click="handleClick">搜索</el-button>
                                    </el-form-item>
                                </el-form>
                                <el-table
                                :data="list.ltv"
                                border
                                style="width: 100% height:100%"
                                height="600" v-loading="loading" element-loading-text="加载中">
                                <el-table-column
                                    fixed
                                    prop="reDate"
                                    label="日期"
                                    width="95"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    fixed
                                    prop="register"
                                    label="新增"
                                    width="60"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_1"
                                    label="1日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_2"
                                    label="2日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_3"
                                    label="3日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_4"
                                    label="4日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_5"
                                    label="5日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_6"
                                    label="6日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_7"
                                    label="7日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_8"
                                    label="8日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_9"
                                    label="9日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_10"
                                    label="10日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_11"
                                    label="11日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_12"
                                    label="12日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_13"
                                    label="13日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_14"
                                    label="14日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_15"
                                    label="15日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_16"
                                    label="16日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_17"
                                    label="17日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_18"
                                    label="18日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_19"
                                    label="19日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_20"
                                    label="20日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_21"
                                    label="21日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_22"
                                    label="22日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_23"
                                    label="23日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_24"
                                    label="24日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_25"
                                    label="25日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_26"
                                    label="26日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_27"
                                    label="27日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_28"
                                    label="28日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_29"
                                    label="29日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_30"
                                    label="30日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_31"
                                    label="31日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_32"
                                    label="32日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_33"
                                    label="33日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_34"
                                    label="34日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_35"
                                    label="35日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_36"
                                    label="36日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_37"
                                    label="37日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_38"
                                    label="38日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_39"
                                    label="39日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_40"
                                    label="40日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_41"
                                    label="41日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_42"
                                    label="42日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_43"
                                    label="43日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_44"
                                    label="44日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_45"
                                    label="45日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_46"
                                    label="46日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_47"
                                    label="47日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_48"
                                    label="48日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_49"
                                    label="49日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_50"
                                    label="50日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>


                                 <el-table-column
                                    prop="ltv_51"
                                    label="51日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_52"
                                    label="52日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_53"
                                    label="53日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_54"
                                    label="54日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_55"
                                    label="55日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_56"
                                    label="56日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_57"
                                    label="57日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_58"
                                    label="58日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_59"
                                    label="59日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_60"
                                    label="60日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>

                            </el-table>
                            <!--表格end-->
                        </el-tab-pane >
                  </el-tabs>
                  <el-tabs type="border-card" v-if="gameId == 55">
                        <el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.gtmzand">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <!--表格start-->
                            <el-table
                                v-loading="loading" element-loading-text="加载中"
                                :data="list.gtmzand"
                                border
                                style="width: 100% height:100%">
                                <el-table-column
                                    fixed
                                    prop="countDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                    v-loading="loading" element-loading-text="加载中"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="addRegNum"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeNum"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payNum"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="payAmountTotal"
                                    label="充值金额"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayNum"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayAmountTotal"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="addPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="activeArppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        </el-tab-pane>
                        <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i>LTV</span>
                             <!--表格start-->
                                <el-form  :inline="true" :model="formInline" class="demo-form-inline">
                                    <el-form-item size="mini" label="开始时间:" :label-position="left">
                                        <el-date-picker
                                            v-model="startDate"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item size="mini" label="结束时间:" :label-position="left">
                                        <el-date-picker
                                            v-model="endDate"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button size="mini" icon="el-icon-search" round @click="handleClick">搜索</el-button>
                                    </el-form-item>
                                </el-form>
                                <el-table
                                :data="list.ltv"
                                border
                                style="width: 100% height:100%"
                                height="600" v-loading="loading" element-loading-text="加载中">
                                <el-table-column
                                    fixed
                                    prop="reDate"
                                    label="日期"
                                    width="95"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    fixed
                                    prop="register"
                                    label="新增"
                                    width="60"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_1"
                                    label="1日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_2"
                                    label="2日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_3"
                                    label="3日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_4"
                                    label="4日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_5"
                                    label="5日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_6"
                                    label="6日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_7"
                                    label="7日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_8"
                                    label="8日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_9"
                                    label="9日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_10"
                                    label="10日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_11"
                                    label="11日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_12"
                                    label="12日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_13"
                                    label="13日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_14"
                                    label="14日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_15"
                                    label="15日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_16"
                                    label="16日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_17"
                                    label="17日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_18"
                                    label="18日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_19"
                                    label="19日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_20"
                                    label="20日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_21"
                                    label="21日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_22"
                                    label="22日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_23"
                                    label="23日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_24"
                                    label="24日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_25"
                                    label="25日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_26"
                                    label="26日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_27"
                                    label="27日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_28"
                                    label="28日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_29"
                                    label="29日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_30"
                                    label="30日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_31"
                                    label="31日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_32"
                                    label="32日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_33"
                                    label="33日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_34"
                                    label="34日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_35"
                                    label="35日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_36"
                                    label="36日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_37"
                                    label="37日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_38"
                                    label="38日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_39"
                                    label="39日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_40"
                                    label="40日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_41"
                                    label="41日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_42"
                                    label="42日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_43"
                                    label="43日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_44"
                                    label="44日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_45"
                                    label="45日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_46"
                                    label="46日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_47"
                                    label="47日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_48"
                                    label="48日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_49"
                                    label="49日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_50"
                                    label="50日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>


                                 <el-table-column
                                    prop="ltv_51"
                                    label="51日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_52"
                                    label="52日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_53"
                                    label="53日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_54"
                                    label="54日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_55"
                                    label="55日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_56"
                                    label="56日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_57"
                                    label="57日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_58"
                                    label="58日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_59"
                                    label="59日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_60"
                                    label="60日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>

                            </el-table>
                            <!--表格end-->
                        </el-tab-pane >
                    </el-tabs>
                  
                  
                  <el-tabs type="border-card" v-if="gameId == 5">
                      <el-tab-pane >
                      <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                          <v-chart :force-fit="true"  :height="400" :data="view.gtmzios">
                              <v-tooltip />
                              <v-axis />
                              <v-legend style="margin-right:40px"/>
                              <v-line position="month*temperature" color="city" />
                              <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                          </v-chart>
                      </el-tab-pane>
                      <el-tab-pane >
                      <span slot="label"><i class="el-icon-date"></i> 表格</span>
                          <!--表格start-->
                          <el-table
                              v-loading="loading" element-loading-text="加载中"
                              :data="list.gtmzios"
                              border
                              style="width: 100% height:100%">
                              <el-table-column
                                  fixed
                                  prop="countDate"
                                  label="日期"
                                  width="100"
                                  align="center"
                              >
                              </el-table-column>
                              <el-table-column
                                  prop="addRegNum"
                                  label="新增"
                                  width="100"
                                  align="center">
                              </el-table-column>
                              <el-table-column
                                  prop="activeNum"
                                  label="活跃"
                                  width="100"
                                  align="center">
                              </el-table-column>
                              <el-table-column
                                  prop="payNum"
                                  label="付费"
                                  width="100"
                                  align="center">
                              </el-table-column>
                                <el-table-column
                                  prop="payAmountTotal"
                                  label="付费金额"
                                  width="100"
                                  align="center">
                              </el-table-column>
                              <el-table-column
                                  prop="addPayNum"
                                  label="新增付费数"
                                  width="100"
                                  align="center">
                              </el-table-column>
                              <el-table-column
                                  prop="addPayAmountTotal"
                                  label="新增充值"
                                  width="100"
                                  align="center">
                              </el-table-column>
                              <el-table-column
                                  prop="addPayRate"
                                  label="新增付费率"
                                  width="100"
                                  align="center">
                              </el-table-column>
                              <el-table-column
                                  prop="activeArpu"
                                  label="arpu"
                                  width="100"
                                  align="center">
                              </el-table-column>
                              <el-table-column
                                  prop="activeArppu"
                                  label="arppu"
                                  width="100"
                                  align="center">
                              </el-table-column>
                          </el-table>
                          <!--表格end-->
                      </el-tab-pane>
                      <el-tab-pane >
                        <span slot="label"><i class="el-icon-date"></i>LTV</span>
                             <!--表格start-->
                                <el-form  :inline="true" :model="formInline" class="demo-form-inline">
                                    <el-form-item size="mini" label="开始时间:" :label-position="left">
                                        <el-date-picker
                                            v-model="startDate"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item size="mini" label="结束时间:" :label-position="left">
                                        <el-date-picker
                                            v-model="endDate"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button size="mini" icon="el-icon-search" round @click="handleClick">搜索</el-button>
                                    </el-form-item>
                                </el-form>
                                <el-table
                                :data="list.ltv"
                                border
                                style="width: 100% height:100%"
                                height="600" v-loading="loading" element-loading-text="加载中">
                                <el-table-column
                                    fixed
                                    prop="reDate"
                                    label="日期"
                                    width="95"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    fixed
                                    prop="register"
                                    label="新增"
                                    width="60"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_1"
                                    label="1日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_2"
                                    label="2日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_3"
                                    label="3日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_4"
                                    label="4日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_5"
                                    label="5日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_6"
                                    label="6日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_7"
                                    label="7日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_8"
                                    label="8日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_9"
                                    label="9日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_10"
                                    label="10日LTV"
                                    width="80"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_11"
                                    label="11日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_12"
                                    label="12日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_13"
                                    label="13日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_14"
                                    label="14日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_15"
                                    label="15日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_16"
                                    label="16日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_17"
                                    label="17日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_18"
                                    label="18日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_19"
                                    label="19日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_20"
                                    label="20日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_21"
                                    label="21日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_22"
                                    label="22日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_23"
                                    label="23日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_24"
                                    label="24日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_25"
                                    label="25日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_26"
                                    label="26日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_27"
                                    label="27日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_28"
                                    label="28日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_29"
                                    label="29日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_30"
                                    label="30日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_31"
                                    label="31日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_32"
                                    label="32日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_33"
                                    label="33日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_34"
                                    label="34日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_35"
                                    label="35日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_36"
                                    label="36日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_37"
                                    label="37日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_38"
                                    label="38日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_39"
                                    label="39日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_40"
                                    label="40日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_41"
                                    label="41日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_42"
                                    label="42日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_43"
                                    label="43日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_44"
                                    label="44日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_45"
                                    label="45日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_46"
                                    label="46日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_47"
                                    label="47日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_48"
                                    label="48日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_49"
                                    label="49日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_50"
                                    label="50日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>


                                 <el-table-column
                                    prop="ltv_51"
                                    label="51日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_52"
                                    label="52日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_53"
                                    label="53日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_54"
                                    label="54日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_55"
                                    label="55日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_56"
                                    label="56日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_57"
                                    label="57日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_58"
                                    label="58日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_59"
                                    label="59日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="ltv_60"
                                    label="60日LTV"
                                    width="90"
                                    align="center">
                                </el-table-column>

                            </el-table>
                            <!--表格end-->
                        </el-tab-pane >
                  </el-tabs>
                        








                    <el-tabs type="border-card" v-if="gameId == 0">
                        <!--el-tab-pane >
                        <span slot="label" ><i class="el-icon-view"></i> 图表</span>
                            <v-chart :force-fit="true"  :height="400" :data="view.lsj">
                                <v-tooltip />
                                <v-axis />
                                <v-legend style="margin-right:40px"/>
                                <v-line position="month*temperature" color="city" />
                                <v-point position="month*temperature" color="city" :size="4" :v-style="style" />
                            </v-chart>
                        </el-tab-pane-->
                       
                        <span slot="label"><i class="el-icon-date"></i> 表格</span>
                            <el-form  :inline="true" :model="formInline" class="demo-form-inline">
                                <el-form-item size="mini" label="开始时间:" :label-position="left">
                                    <el-date-picker
                                        v-model="startDate"
                                        type="date"
                                        placeholder="选择日期"
                                        value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item size="mini" label="结束时间:" :label-position="left">
                                    <el-date-picker
                                        v-model="endDate"
                                        type="date"
                                        placeholder="选择日期"
                                        value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="mini" icon="el-icon-search" round @click="handleClick">搜索</el-button>
                                </el-form-item>
                            </el-form>
                            <!--表格start-->
                            <el-table
                                :data="list.all"
                                border
                                height="420" 
                                show-summary
                                :summary-method = "getSummaries"
                                style="width: 100% height:100%" v-loading="loading" element-loading-text="加载中">
                                <el-table-column
                                    fixed
                                    prop="createDate"
                                    label="日期"
                                    width="100"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="users"
                                    label="新增"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="actives"
                                    label="活跃"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="payUsers"
                                    label="付费"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="money"
                                    label="充值金额"
                                    width="110"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="newPayUsers"
                                    label="新增付费数"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="newMoney"
                                    label="新增充值"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="newPayRate"
                                    label="新增付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                  <el-table-column
                                    prop="payRate"
                                    label="活跃付费率"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="arpu"
                                    label="arpu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="arppu"
                                    label="arppu"
                                    width="100"
                                    align="center">
                                </el-table-column>
                            </el-table>
                            <!--表格end-->
                        
                    </el-tabs>














                  
    </div>
  
</template>

<script>
  const DataSet = require('@antv/data-set');
  export default {
    data() {
      return {
        loading:false,
        svalue: "",
        avalue: "",
        options:null,
        style: { stroke: 'red', lineWidth: 1 },
        gameId: -1,
        deviceType:"1",
        startDate:'',
        endDate:'',
        list:{
            jszq:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],//决胜足球
            lsj:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],//恋世界  2 
            zjfhios:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],// 紫禁繁花IOS 3
            zjfhand:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],// 紫禁繁花AND 33
            srzgios:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],// 塞尔之光IOS 4
            srzgand:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],// 塞尔之光AND 44
            gtmzios:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],// 宫廷秘传IOS 5
            gtmzand:[{"date":"2018-01-01","newUsers":100,"activeUsers":1000}],// 宫廷秘传AND 55
            crmxt:[],// 超燃冒险团
            ltv:[],
            all:[],
        },
        view:{
            jszq:[],
            lsj:[],
            zjfhios:[],// 紫禁繁花IOS 3
            zjfhand:[],// 紫禁繁花AND 33
            srzgios:[],// 塞尔之光IOS 4
            srzgand:[],// 塞尔之光AND 44
            gtmzios:[],// 宫廷秘传IOS 5
            gtmzand:[],// 宫廷秘传AND 55
            crmxt:[],// 超燃冒险团
        },
      };
    },
    mounted(){
        this.startDate = this.getDay(-7);
        this.endDate = this.getDay(0);
        var ttt = this.$route.query.id;
        if(ttt == "1"){
            this.gameId = 4;
            this.avalue = "塞尔之光 / 塞尔之光IOS";
            this.options =  [
                {
          value: '',
          label: '汇总',
          children: [{
            value: 'all',
            label: '所有数据'
          }]
        },{
          value: '',
          label: '决胜足球',
          children: [{
            value: 'jszqand',
            label: '决胜足球and'
          },{
            value: 'jszqios',
            label: '决胜足球iOS'
          },]
        },{
          value: '',
          label: '塞尔之光',
          children: [{
            value: 'srzgand',
            label: '塞尔之光And'
          },{
            value: 'srzgios',
            label: '塞尔之光iOS'
          },{
            value: 'nsrzgios',
            label: '新SDK塞尔之光And'
          },]
        },{
          value: '',
          label: '紫禁繁花',
          children: [{
            value: 'zjfhand',
            label: '紫禁繁花AND'
          },{
            value: 'zjfhios',
            label: '紫禁繁花iOS'
          },{
            value: 'zjfhftand',
            label: '紫禁繁花繁体And'
          },{
            value: 'zjfhftios',
            label: '紫禁繁花繁体iOS'
          },{
            value: 'zjfhywand',
            label: '紫禁繁花英文And'
          },{
            value: 'zjfhtyand',
            label: '紫禁繁花泰语And'
          },{
            value: 'zjfhhgand',
            label: '紫禁繁花韩语And'
          },]
        },{
          value: '',
          label: '恋世界',
          children: [{
            value: 'lsjand',
            label: '恋世界And'
          },{
            value: 'lsjftand',
            label: '恋世界繁体And'
          }]
        }];
        }
        if(ttt == "2"){
            this.gameId = 16;
            this.avalue = "决胜足球 / 决胜足球iOS";
            this.options = [
            {
                value: '',
                label: '决胜足球',
                children: [
                    {
                        value: 'jszqand',
                        label: '决胜足球and'
                    },
                    {
                        value: 'jszqios',
                        label: '决胜足球iOS'
                    },
                    
                ]
            }]
        }
        if(ttt == "3"){
            this.gameId = 4;
            this.avalue = "塞尔之光 / 塞尔之光iOS";
            this.options = [{
            value: '',
            label: '塞尔之光',
            children: [
                {
                    value: 'srzgand',
                    label: '塞尔之光And'
                },
                {
                    value: 'srzgios',
                    label: '塞尔之光iOS'
                },
                {
                    value: 'nsrzgios',
                    label: '新SDK塞尔之光And'
                },
                
            ]
            }];
        }
        if(ttt == "4"){
            this.gameId = 5;
            this.avalue = "紫禁繁花 / 紫禁繁花iOS";
            this.options = [
            {
                value: '',
                label: '紫禁繁花',
                children: [
                {
                    value: 'zjfhand',
                    label: '紫禁繁花AND'
                },
                {
                    value: 'zjfhios',
                    label: '紫禁繁花iOS'
                }
                ]
            }
            ];
        }
        if(ttt == "5"){
            this.gameId = 4;
            this.avalue = "塞尔之光 / 塞尔之光iOS";
            this.options =[
                {
                    value: '',
                    label: '决胜足球',
                    children: [
                        {
                            value: 'jszqand',
                            label: '决胜足球and'
                        },
                        {
                            value: 'jszqios',
                            label: '决胜足球iOS'
                        },
                        
                    ]
                },
                {
                    value: '',
                    label: '塞尔之光',
                    children: [
                        {
                            value: 'srzgand',
                            label: '塞尔之光And'
                        },
                        {
                            value: 'srzgios',
                            label: '塞尔之光iOS'
                        },
                        {
                            value: 'nsrzgios',
                            label: '新SDK塞尔之光And'
                        },
                        
                    ]
                },
                {
                    value: '',
                    label: '紫禁繁花',
                    children: [
                        {
                            value: 'zjfhand',
                            label: '紫禁繁花AND'
                        },
                        {
                            value: 'zjfhios',
                            label: '紫禁繁花iOS'
                        }
                        
                    ]
                },
                {
                    value: '',
                    label: '恋世界',
                    children: [
                        {
                            value: 'lsjand',
                            label: '恋世界And'
                        }
                    ]
                }
            ]
        }
        if(ttt == "6"){
            this.gameId = 11;
            this.avalue = "紫禁繁花 / 紫禁繁花英文And";
            this.options = [
                {
                    value: '',
                    label: '紫禁繁花',
                    children: [
                        {
                            value: 'zjfhftand',
                            label: '紫禁繁花繁体And'
                        },
                        {
                            value: 'zjfhftios',
                            label: '紫禁繁花繁体iOS'
                        },
                        {
                            value: 'zjfhywand',
                            label: '紫禁繁花英文And'
                        }
                        
                    ]
                }
            ];
        }
        if(ttt == "7"){
            this.gameId = 33;
            this.avalue = "紫禁繁花 / 紫禁繁花韩语And";
            this.options = [
                {
                    value: '',
                    label: '紫禁繁花',
                    children: [
                        {
                            value: 'zjfhhgand',
                            label: '紫禁繁花韩语And'
                        }
                    ]
                },
                {
                    value: '',
                    label: '恋世界',
                    children: [
                        {
                            value: 'lsjftand',
                            label: '恋世界繁体And'
                        }
                    ]
                }
            ];
        }
        if(ttt == "8"){
            this.gameId = 17;
            this.avalue = "紫禁繁花 / 紫禁繁花泰语And";
            this.options = [
                {
                    value: '',
                    label: '紫禁繁花',
                    children: [
                        {
                            value: 'zjfhtyand',
                            label: '紫禁繁花泰语And'
                        }
                    ]
                }
            ];
        }
        if(ttt == "9"){
            this.gameId = 17;
            this.avalue = "紫禁繁花 / 紫禁繁花泰语And";
            this.options = [
                {
                    value: '',
                    label: '紫禁繁花',
                    children: [
                        {
                            value: 'zjfhftand',
                            label: '紫禁繁花繁体And'
                        },
                        {
                            value: 'zjfhftios',
                            label: '紫禁繁花繁体iOS'
                        },
                        {
                            value: 'zjfhywand',
                            label: '紫禁繁花英文And'
                        },
                        {
                            value: 'zjfhtyand',
                            label: '紫禁繁花泰语And'
                        },
                    ]
                }
            ];
        }
        this.handleClick();
    },
    methods: {
        
        getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '汇总';
            return;
          }
          if(column.property == "newPayRate" || column.property == "payRate"||column.property == "arpu"||column.property == "arppu" ){
            sums[index] = '';
             return;
          }
        
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            if(column.property == "money" || column.property == "newMoney"){
                sums[index] += '(元)';
            }else{
                sums[index] += '';
            }
          } else {
            sums[index] = 'N/A';
          }
        });

        return sums;
      },
      handleClick:function(){
            this.loading = true;
            if(this.gameId == 28|| this.gameId == 17 || this.gameId == 14 || this.gameId == 16 || this.gameId == 35 ){
                this.jszqList();
                this.deviceType = 1;
                this.ltvprocess();
            }else if( this.gameId == 33 ){
                this.jszqList();
                this.deviceType = 2;
                this.ltvprocess();
            }
            else if(this.gameId == 11){
                this.jszqList();
                this.ltvprocess();
            }


            else if(this.gameId == 2){
                this.deviceType = "1";
                this.lsjList();
                this.lsjLtvProcess();
            }else if(this.gameId == 3){
                this.deviceType = "0";
                this.zjfhiosList();
                //this.zjfhiosLtvProcess();
            }else if(this.gameId == 333){
                this.deviceType = "1";
                this.zjfhandList();
            }else if(this.gameId == 4){
                this.deviceType = "0";
                this.srzgiosList();
                this.srzgiosLtvProcess();
            }else if(this.gameId == 44){
                this.deviceType = "1";
                this.srzgandList();
                this.srzgandLtvProcess();
            }else if(this.gameId == 5){
                this.deviceType = "0";
                this.gtmziosList();
                this.gtmziosLtvProcess();
            }else if(this.gameId == 55){
                this.deviceType = "1";
                this.gtmzandList();
                this.gtmzandLtvProcess();
            }else if(this.gameId == 10){
                this.crmxtList();
            }else if (this.gameId == 0){
                this.all();
            }
      },
      all:function(){
            this.list.all = [];
            this.tajax.post(
                "/api/show",
                this.$qs.stringify({"startDate":this.startDate,"endDate":this.endDate}),
            ) .then((res)=>{
                this.list.all = res.data;
                this.loading = false;
            }).catch(err=>{
                alert(22);
            });
        },
      handleChange(value) {
        this.startDate = this.getDay(-10);
        this.endDate = this.getDay(0);
        if(value == ",zjfhand"){
          this.gameId = 55;
        }
        if(value == ",zjfhios"){
          this.gameId = 5;
        }
        if(value == ",srzgand"){
          this.gameId = 44;
        }
        if(value == ",srzgios"){
          this.gameId = 4;
        }
        if(value == ",zjfhftios"){
          this.gameId = 3;
        }
        if(value == ",zjfhftand"){
          this.gameId = 333;
        }
        if(value == ",jszqand"){
          this.gameId = 14;
        }
        if(value == ",jszqios"){
           this.gameId = 16;
        }
        if(value == ",lsjand"){
            this.gameId = 2
        }
        if(value == ",lsjftand"){
            this.gameId = 28
        }
        if(value == ",zjfhywand"){
          this.gameId = 11
        }
        if(value == ",zjfhtyand"){
          this.gameId = 17
        }
        if(value == ",zjfhhgand"){
          this.gameId = 33
        }
        if(value==",nsrzgios"){
            this.gameId = 35
        }
        if(value==",all"){
            this.gameId = 0
        }
        this.handleClick();
        },
        //新SDK查询ltV
        ltvprocess:function(){
            this.list.ltv = [];
            this.tajax.post(
                "/api/csd/getLtvList",
                this.$qs.stringify({'key':'05b28d17a7b6e7024b6e5d8cc43a8bf7',"gameId":this.gameId,"type":this.deviceType,"beginDate":this.startDate,"endDate":this.endDate}),
            ) .then((res)=>{
                this.list.ltv = res.data;
                this.loading = false;
            }).catch(err=>{
                alert(22);
            });
        },
        //超燃冒险团图表数据
        crmxtView:function () {
            const sourceData = [
            ];
            this.list.crmxt.forEach(
                function (e){
                    e.createDate = e.createDate.substring(0,10);
                    sourceData.push({month:e.createDate.substring(5,10), 新增: e.newUsers, 活跃: e.activeUsers,充值人数:e.orders,付费:e.rechargePrice});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
                type: 'fold',
                fields: ['新增', '活跃','充值人数','付费'],
                key: 'city',
                value: 'temperature',
            });
            this.view.crmxt = dv.rows;
        },
        //超燃冒险团列表数据
        crmxtList:function(){
            this.tajax.post(
                "/api/csd/queryCsds",
                this.$qs.stringify({'key':'05b28d17a7b6e7024b6e5d8cc43a8bf7',"gameId":this.gameId,"beginDate":this.startDate,"endDate":this.endDate}),
            ) .then((res)=>{
                this.list.crmxt = res.data;
                this.crmxtView();
            }).catch(err=>{
                alert(22);
            });
        },


        //决胜足球图表数据
        jszqView:function () {
            const sourceData = [
            ];
            this.list.jszq.forEach(
                function (e){
                    e.createDate = e.createDate.substring(0,10);
                    sourceData.push({month:e.createDate.substring(5,10), 新增: e.newUsers, 活跃: e.activeUsers,充值人数:e.orders,付费:e.rechargePrice});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
                type: 'fold',
                fields: ['新增', '活跃','充值人数','付费'],
                key: 'city',
                value: 'temperature',
            });
            this.view.jszq = dv.rows;
        },
        //决胜足球列表数据
        jszqList:function(){
            this.tajax.post(
                "/api/csd/queryCsds",
                this.$qs.stringify({'key':'05b28d17a7b6e7024b6e5d8cc43a8bf7',"gameId":this.gameId,"beginDate":this.startDate,"endDate":this.endDate}),
            ) .then((res)=>{
                this.list.jszq = res.data;
                this.jszqView();
            }).catch(err=>{
                alert(22);
            });
        },







        //恋世界图表数据
        lsjView:function () {
            const sourceData = [
            ];
            this.list.lsj.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.lsj = dv.rows;
        },
        //恋世界列表数据
        lsjList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":1,'password':123456,"gameType":2,"overseasType":0,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.lsj = res.data.data;
                this.lsjView();
            }).catch(err=>{
                alert(22);
            });
        },
        lsjLtvProcess:function(){
            this.list.ltv = [];
            this.tajax.post(
                "/service/Report/ltv",
                this.$qs.stringify({"deviceType":1,'password':123456,"gameType":2,"overseasType":0,"endDate":this.endDate,"startDay":this.startDate}),
            ) .then((res)=>{
                this.list.ltv = JSON.parse(res.data.data).rows;
                this.loading = false;
            }).catch(err=>{
                alert(22);
            });
        },
         //紫禁繁花IOS图表数据
        zjfhiosView:function () {
            const sourceData = [
            ];
            this.list.zjfhios.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.zjfhios = dv.rows;
            this.loading = false;
        },
         //紫禁繁花IOS列表数据
        zjfhiosList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":3,"overseasType":1,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.zjfhios = res.data.data;
                this.zjfhiosView();
            }).catch(err=>{
                alert(22);
            });
        },
        zjfhiosLtvProcess:function(){
            this.list.ltv = [];
            this.tajax.post(
                "/service/Report/ltv",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":3,"overseasType":1,"endDate":this.endDate,"startDay":this.startDate}),
            ) .then((res)=>{
                this.list.ltv = res.data.data;
            }).catch(err=>{
                alert(22);
            });
        },
        //紫禁繁花android图表数据
        zjfhandView:function () {
            const sourceData = [
            ];
            this.list.zjfhand.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.zjfhand = dv.rows;
            this.loading = false;
        },
         //紫禁繁花android列表数据
        zjfhandList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":3,"overseasType":1,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.zjfhand = res.data.data;
                this.zjfhandView();
            }).catch(err=>{
                alert(22);
            });
        },


         //塞尔之光IOS图表数据
        srzgiosView:function () {
            const sourceData = [
            ];
            this.list.srzgios.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.srzgios = dv.rows;
        },
         //塞尔之光IOS列表数据
        srzgiosList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":4,"overseasType":0,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.srzgios = res.data.data;
                this.srzgiosView();
            }).catch(err=>{
                alert(22);
            });
        },
        srzgiosLtvProcess:function(){
            this.list.ltv = [];
            this.tajax.post(
                "/service/Report/ltv",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":4,"overseasType":0,"endDate":this.endDate,"startDay":this.startDate}),
            ) .then((res)=>{
                this.list.ltv = JSON.parse(res.data.data).rows;
                this.loading = false;
            }).catch(err=>{
                alert(22);
            });
        },
        srzgandLtvProcess:function(){
            this.list.ltv = [];
            this.tajax.post(
                "/service/Report/ltv",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":4,"overseasType":0,"endDate":this.endDate,"startDay":this.startDate}),
            ) .then((res)=>{
                this.list.ltv = JSON.parse(res.data.data).rows;
                this.loading = false;
            }).catch(err=>{
                alert(22);
            });
        },
        //塞尔之光android图表数据
        srzgandView:function () {
            const sourceData = [
            ];
            this.list.srzgand.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.srzgand = dv.rows;
        },
         //塞尔之光android列表数据
        srzgandList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":4,"overseasType":0,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.srzgand = res.data.data;
                this.srzgandView();
            }).catch(err=>{
                alert(22);
            });
        },





         //宫廷秘传IOS图表数据
        gtmziosView:function () {
            const sourceData = [
            ];
            this.list.gtmzios.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.gtmzios = dv.rows;
        },
         //宫廷秘传IOS列表数据
        gtmziosList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":5,"overseasType":0,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.gtmzios = res.data.data;
                this.gtmziosView();
            }).catch(err=>{
                alert(22);
            });
        },
        gtmziosLtvProcess:function(){
            this.list.ltv = [];
            this.tajax.post(
                "/service/Report/ltv",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":5,"overseasType":0,"endDate":this.endDate,"startDay":this.startDate}),
            ) .then((res)=>{
                this.list.ltv = JSON.parse(res.data.data).rows;
                this.loading = false;
            }).catch(err=>{
                alert(22);
            });
        },
        //宫廷秘传android图表数据
        gtmzandView:function () {
            const sourceData = [
            ];
            this.list.gtmzand.forEach(
                function (e){
                    sourceData.push({month:e.countDate.substring(5,10), 新增: parseInt(e.addRegNum), 活跃: parseInt(e.activeNum),充值人数:parseInt(e.payNum),付费:parseInt(e.payAmountTotal)});
                }
            );
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
            type: 'fold',
            fields: ['新增', '活跃','充值人数','付费'],
            key: 'city',
            value: 'temperature',
            });
            this.view.gtmzand = dv.rows;
        },
         //宫廷秘传android列表数据
        gtmzandList:function(){
            this.tajax.post(
                "/service/report/index",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":5,"overseasType":0,"endDate":this.nowDate()}),
            ) .then((res)=>{
                this.list.gtmzand = res.data.data;
                this.gtmzandView();
            }).catch(err=>{
                alert(22);
            });
        },
        gtmzandLtvProcess:function(){
            this.list.ltv = [];
            this.tajax.post(
                "/service/Report/ltv",
                this.$qs.stringify({"deviceType":this.deviceType,'password':123456,"gameType":5,"overseasType":0,"endDate":this.endDate,"startDay":this.startDate}),
            ) .then((res)=>{
                this.list.ltv = JSON.parse(res.data.data).rows;
                this.loading = false;
            }).catch(err=>{
                alert(22);
            });
        },



        nowDate:function() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
            month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
        getDay(day){
        　　var today = new Date();
        　　var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
        　　today.setTime(targetday_milliseconds); //注意，这行是关键代码
        　　var tYear = today.getFullYear();
        　　var tMonth = today.getMonth();
        　　var tDate = today.getDate();
        　　tMonth = this.doHandleMonth(tMonth + 1);
        　　tDate =  this.doHandleMonth(tDate);
        　　return tYear+"-"+tMonth+"-"+tDate;
        },
        doHandleMonth(month){
        　　var m = month;
        　　if(month.toString().length == 1){
          　　m = "0" + month;
        　　}
        　　return m;
        },
    }
  };
</script>


// WEBPACK FOOTER //
// src/report/report.vue